import {graphql, PageProps} from 'gatsby';
import React, {Fragment, memo} from 'react';

import Columns, {Column} from '../components/columns';
import ImageGallery from '../components/image-gallery';
import IntlString from '../components/intl-string';
import IntlStringHtml from '../components/intl-string-html';

import style from './blog.module.scss';

export const query = graphql`
	query BlogPage {
		allBlogPostsJson(sort: {order: ASC, fields: order}) {
			nodes {
				id
				slug
				date {
					...IntlString
				}
				category {
					...IntlString
				}
				title {
					...IntlString
				}
				text {
					...IntlStringHtml
				}
				images {
					...ImageGallery
				}
			}
		}
	}
`;

export default memo(
	/**
	 * @param {PageProps<import("../../tmp/graphql-types").BlogPageQuery>} props
	 * @returns {React.ReactElement} el
	 */
	function BlogPage({data}) {
		return (
			<div className={style.base}>
				{data.allBlogPostsJson.nodes.map((post) => (
					<article className={style.post} key={post.id}>
						<div className={style.postHeaderWrapper}>
							<header className={style.postHeader}>
								<h1 className={style.postCategory}>
									<IntlString {...post.category} />
								</h1>
								<time className={style.postDate}>
									<IntlString {...post.date} />
								</time>
							</header>

							<span className={style.anchor} id={post.slug} />
						</div>

						<div className={style.postBody}>
							<Columns
								columns={[
									new Column({width: 2}, (
										<Fragment>
											<h2 className={style.postTitle}>
												<IntlString handleLines={true} {...post.title} />
											</h2>
											<div className={style.postText}>
												<IntlStringHtml {...post.text} />
											</div>
										</Fragment>
									)),
									new Column({width: 1},
										post.images.length > 0 && (
											<ImageGallery images={post.images} />
										)
									),
								]}
							/>
						</div>
					</article>
				))}

				<div className={style.end} />
			</div>
		);
	}
);
